import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import DropDown from './DropDown';
import Button from './Button';

class DonationLabelsForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedStateError: '',
    };
  }

  onStateChange = state => {
    this.setState({
      selectedStateError: false,
      selectedState: state,
    });
  };

  handleSubmit = e => {
    const { selectedState } = this.state;
    if (selectedState) {
      return false;
    }

    e.preventDefault();
    this.setState({ selectedStateError: true });

    return false;
  };

  renderDropDown = classes => {
    const { defaultText, states } = this.props;
    const { selectedState, selectedStateError } = this.state;

    return (
      <div>
        <input type="hidden" name="state" value={(selectedState && selectedState.key) || ''} />
        <div className={cn('columns medium-6 small-12', classes.name)}>
          <DropDown
            options={states}
            onChange={this.onStateChange}
            selected={selectedState}
            defaultText={defaultText}
            error={selectedStateError}
          />
        </div>
      </div>
    );
  };

  renderButton = classes => (
    <div className={cn('columns medium-6 small-12', classes.name)}>
      <Button
        className={cn('button primary action expand')}
        type="submit"
      >
        <svg
          className="inline-icon inline-icon--download inline-icon--inline inline-icon--sm inline-icon--left"
          viewBox="0 0 16 16"
        >
          <path
            fill="currentColor"
            d="M14 5.452a.5.5 0 01.5.5v7.805a.5.5 0 01-.5.5H2a.5.5 0 01-.5-.5V5.952a.5.5 0 01.5-.5h1.371a.5.5 0 010 1H2.5v6.805h11V6.452h-.871a.5.5 0 010-1H14zm-6.363 5.426l-3.24-3.153a.475.475 0 010-.687.51.51 0 01.706 0l2.352 2.288v-7.34c0-.268.224-.486.5-.486s.499.218.499.486v7.41l2.423-2.358a.51.51 0 01.707 0 .477.477 0 010 .687l-3.24 3.153a.511.511 0 01-.707 0z"
          />
        </svg>
        Download
      </Button>
    </div>
  );

  render() {
    const { classes } = this.props;

    return (
      <div className={cn(classes.donationLabelsSpacer)}>
        <form onSubmit={this.handleSubmit} action="/customer/donationlabel/download" target="_blank">
          <div className={cn('row', classes.nameContainer)}>
            {this.renderDropDown(classes)}
            {this.renderButton(classes)}
          </div>
        </form>
      </div>
    );
  }
}

DonationLabelsForm.propTypes = {
  states: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })),
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  defaultText: PropTypes.string,
};

DonationLabelsForm.defaultProps = {
  states: [
    { key: 'nsw', label: 'NSW / ACT' },
    { key: 'qld', label: 'QLD' },
    { key: 'sa', label: 'SA / NT' },
    { key: 'tas', label: 'TAS' },
    { key: 'vic', label: 'VIC' },
    { key: 'wa', label: 'WA' },
  ],
  defaultText: 'Select your location',
};

export default DonationLabelsForm;
